import Vue from 'vue'
import { Tabs, Form, Input, Select, Button, Icon, message, Modal, Checkbox } from 'ant-design-vue'
import Storage from 'vue-ls'
import SliderCaptcha from '@/components/slider-captcha'
import VerificationCode from '@/components/verification-code'
import MobileInput from '@/components/mobile-input'
import UserIcon from '@/components/icon'

import './css/index.less'

Vue.use(Storage)
Vue.use(Tabs)
Vue.use(Form)
Vue.use(Input)
Vue.use(Select)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Modal)
Vue.use(Checkbox)
Vue.use(UserIcon)
Vue.use(SliderCaptcha)
Vue.use(VerificationCode)
Vue.use(MobileInput)
Vue.prototype.$message = message
